<div class="stp-scrim">
  <dialog class="stp-card" open [attr.aria-label]="title">
    <header class="stp-head">
      <h2>{{ title }}</h2>
      @if (showLayoutToggle) {
        <app-segmented
          class="stp-seg"
          [config]="layoutOptions"
          [value]="mode"
          (valueChange)="onModeChange($event)"
        />
      }
      <button type="button" class="stp-x" aria-label="Close" (click)="onCancel()">
        <app-icon name="x" [size]="16" />
      </button>
    </header>

    <div class="stp-main">
      <nav class="stp-rail" aria-label="Form sections">
        <div class="stp-rail-lb">{{ mode === 'all' ? 'Jump to' : 'Steps' }}</div>
        @for (step of railSteps; track step.id) {
          <button
            type="button"
            class="stp-step"
            [attr.data-status]="step.status ?? 'todo'"
            [attr.aria-current]="step.id === activeStep?.id ? 'step' : null"
            (click)="selectStep(step)"
          >
            <span class="stp-num">
              @if (showTick(step)) {
                <app-icon name="check" [size]="13" />
              } @else if (showError(step)) {
                !
              } @else {
                {{ stepNumber(step) }}
              }
            </span>
            <span class="stp-step-txt">
              <b>{{ step.label }}</b>
              @if (step.description) {
                <small>{{ step.description }}</small>
              }
            </span>
          </button>
        }
        <div class="stp-rail-foot">
          {{ completedCount }} of {{ totalCount }} sections complete
          <div class="stp-prog"><i [style.width.%]="progressPercent"></i></div>
        </div>
      </nav>

      <div #body class="stp-body" (scroll)="onBodyScroll()">
        @if (mode === 'step') {
          <div class="stp-pane">
            @if (!isReviewActive) {
              <div class="stp-eyebrow">{{ stepEyebrow }}</div>
              <h3 class="stp-title">{{ activeStep?.label }}</h3>
            }
            @if (activeStep) {
              <ng-container [ngTemplateOutlet]="templateFor(activeStep.id)" />
            }
          </div>
        } @else {
          @for (step of scrollSteps; track step.id) {
            <section class="stp-sec" [id]="'sec-' + step.id" [attr.data-sec]="step.id">
              <div class="stp-sec-h">
                <div class="stp-sec-t">{{ step.label }}</div>
                @if (step.description) {
                  <p class="stp-sec-help">{{ step.description }}</p>
                }
              </div>
              <ng-container [ngTemplateOutlet]="templateFor(step.id)" />
            </section>
          }
        }
      </div>
    </div>

    <footer class="stp-foot">
      <app-button
        [config]="{ text: cancelLabel, variant: 'outline' }"
        [attr.data-busy-skip]="''"
        (clicked)="onCancel()"
      />
      @if (hint) {
        <span class="stp-hint"><app-icon name="alert" [size]="13" />{{ hint }}</span>
      }
      <span class="stp-sp"></span>
      @if (mode === 'step' && !isReviewActive) {
        @if (!isFirst) {
          <app-button [config]="{ text: 'Back', variant: 'outline' }" (clicked)="onBack()" />
        }
        <app-button
          [config]="{ text: nextLabel, variant: 'solid', loading: busy }"
          (clicked)="onNext()"
        />
      } @else {
        @if (mode === 'step' && !isFirst) {
          <app-button [config]="{ text: 'Back', variant: 'outline' }" (clicked)="onBack()" />
        }
        <app-button
          [config]="{ text: saveLabel, variant: 'solid', loading: busy }"
          (clicked)="onSave()"
        />
      }
    </footer>
  </dialog>
</div>
